<template>
  <v-snackbar v-model="show" :color="type" :timeout="alertTimeout">
    <div class="font-weight-bold">
      {{ alertMessage }}
    </div>
  </v-snackbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'AppAlert',
  computed: {
    ...mapGetters({
      alertMessage: 'alert/message',
      alertShow: 'alert/show',
      alertTimeout: 'alert/timeout',
      type: 'alert/type',
    }),
    show: {
      get() {
        return this.alertShow;
      },
      set() {
        this.resetAlert();
      },
    },
  },
  methods: {
    ...mapActions({
      resetAlert: 'alert/reset',
    }),
  },
};
</script>

<style lang="scss" scoped></style>
